import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ia-agents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ia_agents_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'ia_agents_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'ia_agents_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
